import classNames from 'classnames';
import { FC } from 'react';
import styles from './CharacterCount.module.css';
import { CharacterCountProps } from './CharacterCount.types';

const CharacterCount: FC<CharacterCountProps> = ({ charactersRemaining }) => {
  const ending = charactersRemaining === 1 ? 'character remaining' : 'characters remaining';
  return (
    <div
      aria-live="polite"
      className={classNames({ [styles.charactercount]: true, [styles.error]: charactersRemaining < 0 })}
    >{`${charactersRemaining} ${ending}`}</div>
  );
};

export default CharacterCount;
